export const nodesHints = {
  nodes: 'A node is a computer that participates in the blockchain network. Each node has a full copy of the distributed ledger (blockchain) and follows the protocol for validation and relaying of blocks. Therefore, it serves to maintain and preserve the blockchain data in a decentralized manner.',
  nodeId: 'Unique identifier of a node.',
  host: 'A network address of the node.',
  port: 'A port on which the node communicates.',
  networkId: 'A network which is handled by the node.',
  nodeVersion: 'A version of the node.',
  nodeRevision: 'A revision of the node.',
  nodeVendor: 'A maintainer of the node.',
  os: 'An operation system running on the node.',
}
